<template>
    <div class="balance">
        <div class="common-search-container common-shadow">
            <div class="common-header">
                搜索筛选
            </div>
            <div class="content">
                <el-form
                    :inline="true"
                    :model="searchParams"
                    @keyup.native.enter="getData">
                    <el-form-item>
                        <el-input
                            v-model="searchParams.name"
                            placeholder="昵称"
                            clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            round
                            @click="getData">
                            查询
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <div class="common-table-title">
                <span class="tit">
                    用户留存金列表
                </span>
                <el-button
                    type="primary"
                    @click="exportData"
                    :loading="isExporting"
                    round>
                    导出
                </el-button>
            </div>
            <el-table
                class="table common-shadow"
                :data="tableData"
                v-loading="loading">
                <el-table-column
                    prop="nickname"
                    label="昵称"
                    min-width="90" />
                <el-table-column
                    prop="openId"
                    label="openId"
                    min-width="250" />
                <el-table-column
                    prop="money"
                    label="余额"
                    min-width="100" />
                <el-table-column
                    prop="deposit"
                    label="消保金"
                    min-width="100" />
                <el-table-column
                    prop="state"
                    label="领取状态"
                    min-width="80">
                    <template slot-scope="scope">
                        {{ scope.row.state ? '已领取' : '未领取' }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    min-width="90">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.state"
                            type="text"
                            @click="goDetail(scope.row.userUri)">
                            查看详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="common-table-pagination">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="searchParams.page"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="dataTotal" />
            </div>
        </div>
    </div>
</template>

<script>
import { getHistoryMoney, exportHistoryMoney } from '../../../api';
import { downloadFile } from '../../../utils/util';

export default {
    name: 'HistoryMoneyList',
    data () {
        return {
            isSubmiting: false,
            loading: true,
            tableData: [],
            searchParams: {
                name: '',
                page: 1
            },
            pageSize: 0,
            dataTotal: 0,
            isExporting: false
        };
    },
    created () {
        this.getData();
    },
    methods: {
        async getData (page) {
            try {
                this.loading = true;
                if (page && typeof page === 'number') {
                    this.searchParams.page = page;
                } else {
                    this.searchParams.page = 1;
                }
                const res = await getHistoryMoney(this.searchParams);
                this.loading = false;
                if (res) {
                    const { data, meta } = res;
                    this.tableData = data;
                    if (meta) {
                        this.dataTotal = meta.total;
                        this.pageSize = meta.per_page;
                    }
                }
            } catch (err) {
                console.error(err);
                this.loading = false;
            }

        },
        goDetail (id) {
            this.$router.push({
                name: 'user.show',
                params: {
                    type: 'user',
                    id
                }
            });
        },
        handleCurrentChange (val) {
            this.getData(val);
        },
        async exportData () {
            try {
                if (this.isExporting) return;
                this.isExporting = true;
                const res = await exportHistoryMoney(this.searchParams);
                downloadFile(res, '用户留存金.xlsx');
            } catch (err) {
                console.error(err);
            } finally {
                setTimeout(() => {
                    this.isExporting = false;
                }, 1000);
            }
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
